import { getJeepRallyMediaUrl } from "../../../../../../api/jeep-rally/api";

export const getVisitorApiErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  const message = data?.message || error?.message || fallback;

  if (Array.isArray(data?.errors) && data.errors.length) {
    return `${message}: ${data.errors.join(", ")}`;
  }

  if (typeof data?.error === "string" && data.error) {
    return data.error;
  }

  return message;
};

export const normalizeVisitors = (data) => {
  if (Array.isArray(data)) return data.filter(Boolean);
  if (Array.isArray(data?.data)) return data.data.filter(Boolean);
  if (Array.isArray(data?.users)) return data.users.filter(Boolean);
  return [];
};

export const formatVisitorDate = (dateValue) => {
  if (!dateValue) return "-";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString();
};

export const getVisitorProfileImageUrl = (visitor) => {
  const path = visitor?.profile_image || visitor?.image || "";
  return path ? getJeepRallyMediaUrl(path) : "";
};

export const getVisitorMediaUrl = (pathOrUrl) =>
  pathOrUrl ? getJeepRallyMediaUrl(pathOrUrl) : "";

export const formatVisitorValue = (value) => {
  if (value === 0 || value === false) return String(value);
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
};

export const formatVisitorDateOnly = (dateValue) => {
  if (!dateValue) return "-";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString();
};

export const filterVisitors = (visitors = [], searchTerm = "") => {
  const term = String(searchTerm || "").trim().toLowerCase();
  if (!term) return visitors;

  return visitors.filter((visitor) => {
    const haystack = [
      visitor?.name,
      visitor?.email,
      visitor?.cnic,
      visitor?.contact_number,
      visitor?.occupation,
      visitor?.address,
      visitor?.location,
      visitor?.gender,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return haystack.includes(term);
  });
};
